// extracted by mini-css-extract-plugin
export default {"category":"Category_category__KlhwC","primary":"Category_primary__b8LrL","normal":"Category_normal__y7pbM","active":"Category_active__IRE25"};